import React, { useEffect, useRef, useState } from 'react'
import Table from '../../../components/Admin/Table/Table'
import './previewpage.css'
import CModal from '../../../components/Admin/custom-modal/CModal'
import { useDispatch, useSelector } from 'react-redux'
import StateSelectors from '../../../utils/Admin/constants/selector.constants'
import backIcon from '../../../assets/Admin/arrow-left.svg'
import { postJsonData, resetUploadStatus } from '../../../store/Admin/upload/upload.actions'
import columnMapper from '../../../utils/Admin/helpers/columnMapper'
import validateJson from '../../../utils/Admin/helpers/validateJson'
import { toggleLoading } from '../../../store/Admin/upload/upload.slice'

const PreviewPage = ({ backToUploads, fieldValues }) => {

  const uploads = useSelector(StateSelectors.UPLOAD_SELECTOR)
  const { tokenExpired } = useSelector(StateSelectors.USER_SELECTOR)
  const dispatch = useDispatch()

  const [validationErr, setValidationErr] = useState(false)

  const modalRef = useRef()

  useEffect(() => {

    if (uploads.isUploadSuccess === true || uploads.hasUploadFailure === true) {
      handleModal()
    }

  }, [uploads])

  useEffect(() => {
    if (tokenExpired === true) {
      modalRef.current.showModalContent('failure', 'Token expired. Navigating to login screen', true)
    }
  }, [tokenExpired])


  const handleUploadRedirection = () => {
    backToUploads(true)
    modalRef.current.modalVisibility(false)
    dispatch(resetUploadStatus())
  }

  const handleModal = () => {
    if (uploads.isUploadSuccess === true) {
      modalRef.current.showModalContent('success', 'your document uploaded successfully', true)
    } else {
      modalRef.current.showModalContent('failure', uploads.uploadErrorMsg, true)
    }
  }


  const validateData = () => {

    let validatorResponse = validateJson(uploads.uploadJsonData, fieldValues.distributor?.toLowerCase())
    console.log(validatorResponse);

    if (validatorResponse.hasError === true) {
      setValidationErr(true)
      if (validatorResponse.errorType === 'not array' || validatorResponse.errorType === 'invalid input' ) {
        modalRef.current.showModalContent('failure', 'Invalid input payload. Unable to perform validation', true)
      } else if (validatorResponse.errorType === 'column length') {
        modalRef.current.showModalContent('warning', `Number of required columns for ${fieldValues.distributor?.toLowerCase()} Broker is incorrect.`, true)
        modalRef.current.setFooterDetails({ noOfBtns: 2, showCancel: true, showProceed: true, cancelBtnLabel: 'Go to uploads', proceedBtnLabel: 'upload anyway'})
      } else if (validatorResponse.errorType === 'inequal column') {
        modalRef.current.showModalContent('warning', `Column names in the uploaded file do not match with ${fieldValues.distributor?.toLowerCase()} Broker Column Names.`, true)
        modalRef.current.setFooterDetails({ noOfBtns: 2, showCancel: true, showProceed: true, cancelBtnLabel: 'Go to uploads', proceedBtnLabel: 'upload anyway'})
      }
    } else {
      setValidationErr(false)
      postData()
    }

  }
  
  const postData = () => {
    modalRef.current.modalVisibility(false)
    dispatch(toggleLoading(true))
    const jsonData = columnMapper(uploads.uploadJsonData, fieldValues.distributor?.toLowerCase())
    
    if (Object.values(jsonData[0]).length === 0) {
      dispatch(postJsonData(uploads.uploadJsonData, fieldValues.distributor?.toLowerCase()))
    } else {
      dispatch(postJsonData(jsonData, fieldValues.distributor?.toLowerCase()))
    }
  }

  return (
    <div className="bg-white preview-section h-100 mx-md-2 mx-lg-5 mx-xl-5">
      <div className="px-3 py-4 preview-section-header mb-4 d-flex align-items-center">
        <button onClick={() => backToUploads(false)} type='button bg-white' className="cursor-pointer back-btn text-capitalize px-3 cl-custom-grey">
          <img width="21" height="21" src={ backIcon } alt="back" />
        </button>
        <h5 className='text-capitalize mb-0'>preview MIS information</h5>
      </div>
      <div className="px-3 pt-0 paddingbottom40">

        <div className="row no-row-margin align-items-start preview-details-container mb-4">
          <div className="col-5">
            <div className="preview-details-label cl-custom-grey text-capitalize">selected distributor</div>
            <p className="mb-0 text-capitalize preview-details-value fs-16px">{ fieldValues.distributor }</p>
          </div>
          <div className="col-5">
            <div className="preview-details-label cl-custom-grey text-capitalize">uploaded type</div>
            <p className="mb-0 text-capitalize preview-details-value fs-16px">{ fieldValues.fileType }</p>
          </div>
          <div hidden={ fieldValues.fileType.toLowerCase() === 'api' } className="col-5 paddingTop40 mb-2">
            <div className="preview-details-label cl-custom-grey text-capitalize">file uploaded</div>
            <p className="mb-0 preview-details-value fs-16px">{ fieldValues.fullFileName }</p>
          </div>

          <div hidden={ fieldValues.fileType.toLowerCase() !== 'api' } className="col-5 mt-4 mb-2">
            <div className="preview-details-label cl-custom-grey text-capitalize">URL</div>
            <p className="mb-0 preview-details-value fs-16px">{ fieldValues.APIUrl }</p>
          </div>
        </div>
        
        {
          uploads.uploadJsonData?.length ?
            <Table tableFor="preview" tableData={uploads.uploadJsonData} />
            : null
        }

        <div className="text-center mb-4">
          <button type="button" onClick={validateData} className="w-25 form-upload-btn mt-4 text-capitalize text-white px-3 py-2 py-lg-3 py-xl-3 no-shadow">submit</button>  
        </div>
        <CModal
          ref={modalRef}
          callbackFunc={
            uploads.isUploadSuccess === true || uploads.hasUploadFailure === true ? handleUploadRedirection : () => modalRef.current.modalVisibility(false)
          }
          onClickProceed={postData}
          onClickCancel={handleUploadRedirection}
        />
      </div>
    </div>
  )
}

export default PreviewPage